import React from "react";
import { InlineMath } from "react-katex";
import {
  makeSimpleClosedTask,
  normalizeMay2026Variant,
  pick,
} from "../../../../matura/MaturaMay2026ClosedTaskSupport";

const VARIANTS = [
  { ins: 40, central: 20, result: 60 },
  { ins: 55, central: 40, result: 70 },
  { ins: 45, central: 30, result: 60 },
  { ins: 60, central: 50, result: 70 },
  { ins: 35, central: 20, result: 50 },
  { ins: 50, central: 40, result: 60 },
  { ins: 65, central: 60, result: 70 },
  { ins: 45, central: 20, result: 70 },
];

function TaskPrompt({ inscribedDeg, centralDeg }) {
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <div>
        Punkty <InlineMath math="A,\;B,\;C" /> oraz <InlineMath math="D" /> leżą na okręgu
        o środku w punkcie <InlineMath math="O" />.
      </div>
      <div>
        Punkt <InlineMath math="O" /> leży na odcinku <InlineMath math="BD" />. Kąt{" "}
        <InlineMath math="CDA" /> ma miarę <InlineMath math={`${inscribedDeg}^{\\circ}`} />, a kąt{" "}
        <InlineMath math="COB" /> ma miarę <InlineMath math={`${centralDeg}^{\\circ}`} />.
      </div>
      <div>
        Miara ostrego kąta <InlineMath math="BOA" /> jest równa:
      </div>
    </div>
  );
}

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const data = variant === "original" ? { ins: 50, central: 30, result: 70 } : pick(VARIANTS);

  return makeSimpleClosedTask({
    type: "MaturaCircleInscribedCentralAngleClosedTask",
    taskNumber: "19",
    variant,
    prompt: TaskPrompt({ inscribedDeg: data.ins, centralDeg: data.central }),
    correct: `${data.result}^\\circ`,
    wrong: [`${data.result - 10}^\\circ`, `${data.result + 10}^\\circ`, `${2 * data.ins}^\\circ`],
    tags: ["okrąg", "kąt wpisany", "kąt środkowy"],
    data: { ...data, kind: "circleAngles" },
    explanationSteps: [
      {
        title: "Kąt środkowy oparty na tym samym łuku ma miarę dwa razy większą od kąta wpisanego.",
        latex: `2\\cdot${data.ins}^\\circ=${2 * data.ins}^\\circ`,
      },
      {
        title: <>Od otrzymanego kąta środkowego odejmujemy dany kąt <InlineMath math="COB" />.</>,
        latex: `${2 * data.ins}^\\circ-${data.central}^\\circ=${data.result}^\\circ`,
      },
    ],
  });
}

export {
  checkClosedAnswer as checkAnswer,
  renderClosedAnswer as renderAnswer,
  renderClosedExplanation as renderExplanation,
  renderClosedInput as renderInput,
  renderClosedTask as renderTask,
  renderClosedUserAnswer as renderUserAnswer,
} from "../../../../matura/MaturaMay2026ClosedTaskSupport";
